import { FC, PropsWithChildren } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Typography } from '@mui/material';

import useAuthentication from '@/components/Authentication/useAuthentication';
import { Button } from '@/designSystem/Button/Button';
import useNavigation from '@/shared/Hooks/useNavigation';
import { useIsMobile } from '@/utils/useResponsive';

import messages from './messages';

import useStyles from './styles';

const SearchFloater: FC<
  PropsWithChildren<{ showLoginSignupModal: () => void }>
> = ({ showLoginSignupModal }) => {
  const { classes } = useStyles();
  const { pushTo, urls } = useNavigation();
  const { authentication } = useAuthentication();
  const { formatMessage } = useIntl();
  const isMobile = useIsMobile();

  const handleClick = () => {
    if (authentication?.isAuthenticated) {
      pushTo(
        urls.drawerStudentNeed({
          originButton: 'search',
        })
      );
    } else {
      showLoginSignupModal();
    }
  };

  return (
    <button
      className={classes.searchFloaterContainer}
      onClick={handleClick}
      type="button"
    >
      <div className={classes.textContainer}>
        <Typography variant="title2Xs" component="h6">
          <FormattedMessage {...messages.title} />
        </Typography>
        <Typography
          variant="bodyLg"
          component="p"
          className={classes.searchFloaterSubTitle}
        >
          <FormattedMessage {...messages.subtitle} />
        </Typography>
      </div>
      <Button
        color="brand"
        size="medium"
        label={formatMessage(messages.button)}
        isFullWidth={isMobile}
      />
    </button>
  );
};

export default SearchFloater;
